import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import { performUpdateLessonSubchapters } from '@/utils/courseStudio/subchapter';
import { performCreateSubchaptersIntoLessons } from '@/utils/courseStudio/subchapter';

async function performCreateSubchaptersIntoLessonsChapters(
  newBlocks: TempLessonBlock[],
) {
  const createdBlocks: TempLessonBlock[] = [];

  for (const block of newBlocks) {
    const createdSubchapters = await performCreateSubchaptersIntoLessons(
      block.lessons,
    );

    createdBlocks.push({ ...block, lessons: createdSubchapters });
  }

  return createdBlocks;
}

async function performUpdateSubchaptersIntoLessonsChapters(
  currentBlocks: TempLessonBlock[],
  newBlocks: TempLessonBlock[],
): Promise<TempLessonBlock[]> {
  const updatedBlocks: TempLessonBlock[] = [];

  for (const newBlock of newBlocks) {
    const currentBlock = currentBlocks.find(
      b => b.id === newBlock.id || !!newBlock.tempId,
    );

    const updatedLessons = await performUpdateLessonSubchapters(
      currentBlock?.lessons || [],
      newBlock.lessons,
    );

    updatedBlocks.push({
      ...newBlock,
      lessons: updatedLessons,
    });
  }

  return updatedBlocks;
}

export function useCourseStudioSubchapters() {
  async function handleCreateSubchapters(newBlocks: TempLessonBlock[]) {
    const createdBlocks = await performCreateSubchaptersIntoLessonsChapters(
      newBlocks,
    );

    return createdBlocks;
  }

  async function handleUpdateSubchapters(
    currentBlocks: TempLessonBlock[],
    newBlocks: TempLessonBlock[],
  ) {
    const updatedBlocks = await performUpdateSubchaptersIntoLessonsChapters(
      currentBlocks,
      newBlocks,
    );

    return updatedBlocks;
  }

  return {
    handleCreateSubchapters,
    handleUpdateSubchapters,
  };
}
